import { render, staticRenderFns } from "./BaseCartaoPontoSemsa.vue?vue&type=template&id=5a3babe8"
import script from "./BaseCartaoPontoSemsa.vue?vue&type=script&lang=js"
export * from "./BaseCartaoPontoSemsa.vue?vue&type=script&lang=js"
import style0 from "./BaseCartaoPontoSemsa.vue?vue&type=style&index=0&id=5a3babe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports